namespace GeniuzPOS.Product {
    export class PsSetItemDtColumns {
        static columnsKey = 'Product.PsSetItemDt';
    }
}
